import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Disc3, Loader2 } from "lucide-react";
import { toast } from "sonner";

const inputCls =
  "w-full bg-ink border border-stroke px-4 py-3 font-mono text-sm text-paper placeholder:text-muted-gray focus:outline-none focus:border-acid transition-colors";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/app" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/app");
    } else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Disc3 className="text-acid" size={30} />
          <span className="font-display text-4xl text-paper">POSTERVAULT</span>
        </Link>
        <div className="bg-surface/85 backdrop-blur-md border border-stroke p-8 hard-shadow">
          <h1 className="font-display text-4xl text-paper mb-1">Log In</h1>
          <p className="font-mono text-xs text-muted-gray mb-6">Your favorite poster portfolios</p>
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="login-email-input" type="email" required placeholder="EMAIL" className={inputCls}
              value={email} onChange={(e) => setEmail(e.target.value)} />
            <input data-testid="login-password-input" type="password" required placeholder="PASSWORD" className={inputCls}
              value={password} onChange={(e) => setPassword(e.target.value)} />
            {error && <div data-testid="login-error" className="font-mono text-xs text-magenta border border-magenta/40 bg-magenta/10 px-3 py-2">{error}</div>}
            <button type="submit" disabled={loading} data-testid="login-submit-button"
              className="w-full bg-acid text-ink font-bold font-mono text-sm uppercase tracking-wider py-3.5 hover:bg-glow disabled:opacity-50 flex items-center justify-center gap-2">
              {loading && <Loader2 size={16} className="animate-spin" />} Enter Vault
            </button>
          </form>
          <p className="font-mono text-xs text-muted-gray mt-6 text-center">
            No account? <Link to="/register" className="text-acid hover:underline">Register</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
